import { useStore } from "@/store";
import { flashWarning } from "@/utils";

export const fetchDiabetesBehandlingsform = async ({ query }: { query?: string } = {}) => {
    const store = useStore();

    try {
        const params: { q?: string } = {};

        if (query) {
            params.q = query;
        }

        const { subsetName } = await store.dispatch("operation/diabetesBehandlingsform/fetchDiabetesBehandlingsform", {
            filterParams: params,
            displayMode: true,
        });

        return store.getters["operation/diabetesBehandlingsform/diabetesBehandlingsformSubset"]({
            subsetName,
            displayMode: true,
        });
    } catch (error) {
        flashWarning("Kunde inte hämta behandlingsformer för diabetes.");
    }
};
